import api from "./api";
import { MerchantLogEntryDto } from "../interfaces/Dtos/logDTO";
import { alertService } from "./alertService";

const baseURL = process.env.REACT_APP_API_HOST + "/log";

export const merchantLogService = async (request: MerchantLogEntryDto) => {

    request.creationDate = new Date().toISOString();

    try {
        const response = await api.post(`${baseURL}/InsertMerchantLog`, request);
        if (response && response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const message = (error as any)?.response?.data?.errorMessage || "Error al registrar el log de merchant";
        alertService.error("Error al registrar el log", message);
    }

}